import React, { Fragment } from "react";
import { Footerdark, PageLayout } from "../../../Constant";
import UserAgentForm from "./UserAgentForm";

const UserAgentAdd = () => {
    return (
        <Fragment>
            <UserAgentForm mainTitle={Footerdark} title={Footerdark} parent={PageLayout} />         
        </Fragment>
    )
}
export default UserAgentAdd;